import { render, staticRenderFns } from "./Parents.vue?vue&type=template&id=3ffdaad7&"
import script from "./Parents.vue?vue&type=script&lang=js&"
export * from "./Parents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports